import api from "@/lib/axios";
// import { logoutViaApi } from '@/redux/helpers/misc';
import { logoutUser } from "@/redux/slices/userSlice";
import { RootState, AppDispatch } from "@/redux/store";
import { useSelector, useDispatch, useStore } from "react-redux";
import Cookies from 'js-cookie';

const useUserProps = () => {
   const useAppDispatch = useDispatch.withTypes<AppDispatch>();
   const dispatch = useAppDispatch();
   const store = useStore<RootState>();

   const useAppSelector = useSelector.withTypes<RootState>()
   const { user, userInfo, userAuth, plainUserInfo, isRerouting, isAuthenticated } = useAppSelector((state) => state.user)

   /** Use when you need the latest userInfo at call time (e.g. in event handlers), not the value from last render. */
   const getLatestUserInfo = () => store.getState().user.userInfo
   /** Use when you need the latest plainUserInfo at call time. */
   const getLatestPlainUserInfo = () => store.getState().user.plainUserInfo
   const { userWallets, userTierInfo } = useAppSelector((state) => state.dashboard)
   const allUserWalletCurrs = userWallets?.map((item: any) => item.cur)

   const userFirstName = userInfo?.firstName;
   const userLasttName = userInfo?.lastName;
   const userFullName = `${userInfo?.lastName} ${userInfo?.firstName}`;

   const isValidUser = user !== null && isAuthenticated === true;
   const userToken = typeof window === 'undefined' ? '' : Cookies.get("qwid-token");
   const userNamesAreValid = userInfo?.lastName?.length && userInfo?.firstName?.length;

   const userId = userInfo?.userId || plainUserInfo?.userId || "";
   const userEmail = userInfo?.email;
   const trxPinExists = user?.transactionPin === true;
   const mfaIsValid = userAuth?.find(
      (item: any) => item.type === "2fa" && item?.status === 1
   );

   const userObj: any = plainUserInfo?.emailVerify
      ? plainUserInfo
      : user?.endUser
         ? user?.endUser[0]
         : user?.enduser[0];

   const userTierLevel = userTierInfo?.level || user?.kyc?.kycTier?.level;
   const isTierOneUser = userTierLevel === 1;
   const isTierTwoUser = userTierLevel === 2;
   const isTierThreeUser = userTierLevel === 3;

   const countrycode = userInfo?.countryCode;
   const countryName = userInfo?.country;

   const kyclevel = plainUserInfo;
   const storedUser = localStorage.getItem("persist:root");

   const endUserSession = async () => {
      try {
         await api.patch(`logout`);
         setTimeout(() => {
            dispatch(logoutUser());
            if (storedUser) {
               localStorage.removeItem("persist:root")
            }
         }, 50);
         window.location.href = "/";
      } catch (error: any) {
         if (error.status === 401) {
            Cookies.remove("qwid-token");
         }
         return error;
      }
   };

   return {
      user,
      userId,
      userInfo,
      getLatestUserInfo,
      getLatestPlainUserInfo,
      userToken,
      isValidUser,
      userEmail,
      userFullName,
      userFirstName,
      userLasttName,
      userNamesAreValid,
      trxPinExists,
      mfaIsValid,
      userObj,
      countrycode,
      countryName,
      kyclevel,
      isTierOneUser,
      isTierTwoUser,
      isTierThreeUser,
      userTierLevel,
      userWallets,
      allUserWalletCurrs,
      endUserSession,
      isRerouting,
      isAuthenticated,
   }
}

export default useUserProps;
